export let originconfig = {
   domain: ''//生产环境
   // domain: '/api'//开发环境
}




//////////////////
// WEBPACK FOOTER
// ./static/apiConfig/originConfig.js
// module id = lp9j
// module chunks = 19